import React, { useContext, useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';

import DevolutionIcon from '../../assets/icons/PackageReturn.svg';
import DocumentTextEditIcon from '../../assets/icons/DocumentTextEdit.svg';
import CreditcardIcon from '../../assets/icons/CreditcardRepeat.svg';
import BagShoppingIcon from '../../assets/icons/BagShoppingRefresh.svg';
import CuponDiscountIcon from '../../assets/icons/CuponDicount.svg';
import SettingsFilterIcon from '../../assets/icons/SettingsFilter3.svg';
import IntegrationsSvg from '../../assets/icons/Integrations.svg';
import LaptopMobile from '../../assets/icons/LaptopMobile.svg';
import IconEmailSvg from '../../assets/icons/Email.svg';
import SettingsGear from '../../assets/icons/SettingsGear.svg';

import { GeneralContext } from '../../core/app-context/GeneralContext';
import { GridLayout, Configs, Methods, Overview, Reasons } from './styles';
import {
  Spacer,
  Text,
  PrivatePageStructure,
  ConfigCard,
  Divider,
  ProgressBar,
  Modal,
} from '../../shared/components';
import UserInfo from './components/UserInfo';
import DevolutionMethodCard from './components/DevolutionMethodCard';
import OverviewCard from './components/OverviewCard';
import DemoVideoCard from './components/DemoVideoCard';
import ConfigurationStatusCard from './components/ConfigurationStatusCard';
import DateFilterModal from './components/DateFilterModal';
import useGetDashData from './hooks/useGetDashData';
import usePageStore from './store/pageStore';

export default function Dashboard() {
  const { setSideMenu, setIdMenuSelected } = useContext(GeneralContext);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false); // TODO change to false
  const navigate = useNavigate();
  const loadingDashConfigs = usePageStore((state) => state.loadingDashConfigs);
  const dashData = usePageStore((state) => state.dashData);

  useEffect(() => {
    setSideMenu('reversa');
    setIdMenuSelected('home');
  }, [setSideMenu, setIdMenuSelected]);

  useGetDashData();

  return (
    <>
      <PrivatePageStructure
        disableButtons
        disableHeaderSpacer
        title={<UserInfo />}
        loading={loadingDashConfigs}
      >
        <GridLayout>
          <Overview>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Text.h3>Overview</Text.h3>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                  position: 'relative',
                }}
              >
                {/* <SVG
                  className="svg"
                  src={SettingsFilterIcon}
                  width={23}
                  color="var(--color-gray-50)"
                  cursor="pointer"
                  onClick={() => setOpenFilterModal((prev) => !prev)}
                />
                {openFilterModal && <DateFilterModal />} */}
              </div>
            </div>
            <Spacer.vertical size={20} />
            <ConfigCard>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  flexWrap: 'wrap',
                  width: '100%',
                }}
              >
                <OverviewCard
                  icon={
                    <SVG
                      className="svg"
                      src={DevolutionIcon}
                      width={23}
                      color="var(--color-blue-primary)"
                    />
                  }
                  title="Total de devoluções"
                  value={dashData?.devolutions.total || 0}
                />
                <Divider.Vertical />
                <OverviewCard
                  icon={
                    <SVG
                      className="svg"
                      src={BagShoppingIcon}
                      width={23}
                      color="var(--color-blue-primary)"
                    />
                  }
                  title="Trocas por produtos"
                  value={dashData?.devolutions.exchanged || 0}
                />
                <Divider.Vertical />
                <OverviewCard
                  icon={
                    <SVG
                      className="svg"
                      src={CreditcardIcon}
                      width={23}
                      color="var(--color-blue-primary)"
                    />
                  }
                  title="Reembolsos"
                  value={dashData?.devolutions.refunded || 0}
                />
                <Divider.Vertical />
                <OverviewCard
                  icon={
                    <SVG
                      className="svg"
                      src={CuponDiscountIcon}
                      width={23}
                      color="var(--color-blue-primary)"
                    />
                  }
                  title="Créditos fornecidos"
                  value={dashData?.devolutions.credits || 0}
                />
              </div>
            </ConfigCard>
          </Overview>
          <Configs>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Text.h3>Configure sua conta</Text.h3>
              <ProgressBar
                percentage={_calculateConfigPercentage(dashData?.configs)}
                width="30%"
                color="#00D027"
              />
            </div>
            <Spacer.vertical size={20} />
            <DemoVideoCard videoClickCallback={() => setOpenVideoModal(true)} />
            <Spacer.vertical size={20} />
            <ConfigurationStatusCard
              title="Configure as informações básicas da loja"
              subtitle="Configure as informações básicas da loca, como nome, CNPJ e endereço."
              completed={dashData?.configs.storeInfo || false}
              icon={DocumentTextEditIcon}
              clickCb={() => navigate('/profile', { replace: true })}
            />
            <Spacer.vertical size={10} />
            <ConfigurationStatusCard
              title="Configure a integração com os serviços CliqueRetire"
              subtitle="Configure as chaves de API para integração com os serviços da CliqueRetire."
              completed={dashData?.configs.cliqueRetireIntegration || false}
              icon={IntegrationsSvg}
              clickCb={() => navigate('/integrations', { replace: true })}
            />
            <Spacer.vertical size={10} />
            <ConfigurationStatusCard
              title="Configure a integração com os serviços dos Correios"
              subtitle="Configure as chaves de API para integração com os serviços dos Correios."
              completed={dashData?.configs.correiosIntegration || false}
              icon={IntegrationsSvg}
              clickCb={() => navigate('/integrations', { replace: true })}
            />
            <Spacer.vertical size={10} />
            <ConfigurationStatusCard
              title="Configure a página de devolução"
              subtitle="Configure os aspectos visuais da página de devolução da sua loja."
              completed={dashData?.configs.devolutionPageConfig || false}
              icon={LaptopMobile}
              clickCb={() =>
                navigate('/devolution-page-configs', { replace: true })
              }
            />
            <Spacer.vertical size={10} />
            <ConfigurationStatusCard
              title="Edite as configurações e regras de devolução da loja"
              subtitle="Configure as preferências do fluxo de devolução, motivos de devolução, categorias, entre outros."
              completed={dashData?.configs.configsAndRules || false}
              icon={SettingsGear}
              clickCb={() => navigate('/rules', { replace: true })}
            />
            <Spacer.vertical size={10} />
            <ConfigurationStatusCard
              title="Configure os emails disparados pela plataforma"
              subtitle="Configure emails transacionais disparados pela plataforma durante o processo de devolução."
              completed={dashData?.configs.customEmails || false}
              icon={IconEmailSvg}
              clickCb={() => navigate('/emails', { replace: true })}
            />
          </Configs>
          <Methods>
            <Text.h3>Métodos de devolução</Text.h3>
            <Spacer.vertical size={20} />
            <ConfigCard flexDirection="column">
              <DevolutionMethodCard
                methodIndex={1}
                devolutions={
                  dashData?.devolutions.methods.find(
                    (method) => method.index === 1,
                  )?.devolutions || 0
                }
              />
              <Spacer.vertical size={15} />
              <Divider.Horizontal />
              <Spacer.vertical size={15} />
              <DevolutionMethodCard
                methodIndex={2}
                devolutions={
                  dashData?.devolutions.methods.find(
                    (method) => method.index === 2,
                  )?.devolutions || 0
                }
              />
            </ConfigCard>
          </Methods>
          <Reasons>
            <Text.h3>Principais motivos</Text.h3>
            <Spacer.vertical size={20} />
            <ConfigCard flexDirection="column" alignItems="flex-start">
              {dashData?.devolutions.reasons.map((reason, index) => {
                const percentage = () => {
                  if (!dashData?.devolutions.total) return 0;
                  return (
                    (reason.devolutions / dashData?.devolutions.total) *
                    100
                  ).toFixed(1);
                };
                return (
                  <React.Fragment key={reason.id}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <Text.small>{reason.name}</Text.small>
                      <Text.normal>{`${percentage()}%`}</Text.normal>
                    </div>
                    <Spacer.vertical size={10} />
                    <ProgressBar percentage={percentage()} />
                    {index !== dashData?.devolutions.reasons.length - 1 && (
                      <Spacer.vertical size={25} />
                    )}
                  </React.Fragment>
                );
              })}
            </ConfigCard>
          </Reasons>
        </GridLayout>
      </PrivatePageStructure>
      <Modal
        overlay
        title="Vídeo tutorial"
        show={openVideoModal}
        closeCb={() => setOpenVideoModal(false)}
      >
        <ReactPlayer
          url="https://www.youtube.com/watch?v=s5x8fHVkDrw"
          config={{ youtube: { playerVars: { showinfo: 2 } } }}
        />
      </Modal>
    </>
  );
}

function _calculateConfigPercentage(configs) {
  if (!configs) return 0;
  const totalConfigs = 6;
  const completedConfigs = Object.values(configs).filter(
    (value) => value === true,
  ).length;
  return (completedConfigs / totalConfigs) * 100;
}
